export default {
    SET_LIMIT_ORDERS(state, payload) {
        state.limitOrders = payload;
    },
    SET_EXTRA_MEALS(state, payload) {
        state.extraMeals = payload;
    },
};
